// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u2k86{display:flex;flex-direction:column;gap:32px;padding:16px 0px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keeperModalContainer": `u2k86`
};
export default ___CSS_LOADER_EXPORT___;
